import upp from 'app/app.module';

DisplayAddressComponent.$inject = [ '$scope' ];
function DisplayAddressComponent($scope) {
    Object.defineProperties(this, {
        address: {
            get: function() { return $scope['value'] },
        }
    });
}

upp.directive('displayAddress', function() {
    return {
        restrict: 'E',
        scope: { value: '=', },
        templateUrl: require('./display-address.component.html'),
        styles: require('./display-address.component.less'),
        controllerAs: '$ctrl',
        controller: DisplayAddressComponent,
    };
});



// WEBPACK FOOTER //
// ./src/app/common/components/display-address/display-address.component.js